import { writable } from 'svelte/store';

export const searchOpen = writable(false);
export const user = writable(null);
export let flashError = writable(null);
export let flashSuccess = writable(null);
export let flashSuccessMessage = writable(null);
export let flashErrorMessage = writable(null);
export let userFeatures = writable(null);
export let userData = writable(null);
//export const authToken = writable('');
export let authToken;


if(typeof window !== "undefined") {
    authToken = writable(sessionStorage.getItem("authToken") || "");
} else {
    authToken = writable(null);
}

export const sessionStorageSet = (key, value) => {
    sessionStorage.setItem(key, value);
}

export const sessionStorageGet = (key) => {
    sessionStorage.getItem(key);
}

export const sessionStorageRemove = (key) => {
    sessionStorage.removeItem(key);
}
